import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  Input,
  DatePicker,
  Select,
  Typography,
  Space,
  Tag,
  Drawer,
  Divider,
  Button,
  Form,
  List,
  Avatar,
  Image,
  Alert,
  Row,
  Col,
  Upload,
  message,
  Statistic,
  Card,
  Tooltip,
} from "antd";

import dayjs from "dayjs";
import axios from "axios";
import constants from "../../constants";
import { EditOutlined, UploadOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import RegisterPayment from "./RegisterPayment";
import UploadDocument from "./UploadDocument";
import { useAuth } from "../../contexts/authContext";
import Meta from "antd/es/card/Meta";

function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}

const tailLayout = {
  wrapperCol: { offset: 0, span: 24 },
};

const Discrepencies = () => {
  const { Option } = Select;
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [drawerData, setDrawerData] = useState(false);

  const [form] = Form.useForm();

  const { getToken } = useAuth();

  const fetchLeadsFromServer = async (query) => {
    try {
      const token = await getToken();
      const headers = {
        authorization: `bearer ${token}`,
      };

      const url = `${constants.NEW_DOMAIN}/api/v1/channelPartnerLeads/leadsWithQuery`;
      const res = await axios.get(url, {
        headers,
      });

      return {
        data: res.data?.data,
      };
    } catch (error) {
      throw new Error(error?.message || "something went wrong , try again later");
    }
  };

  const updateRowAfterUpload = (id, key, records) => {
    rows.map((data) => {
      if (data._id === id) {
        setDrawerData({ ...data, [key]: records });
      }
    });

    setRows((prev) => {
      return prev.map((data) => {
        if (data._id === id) {
          return { ...data, [key]: records };
        } else {
          return data;
        }
      });
    });
  };

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");

    fetchLeadsFromServer()
      .then((res) => {
        if (cancelled) return;
        setRows(res.data);
        setTotal(res.total);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e?.message || "Failed to load leads");
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const updateDetails = async (form) => {
    console.log(form);

    const formData = new FormData();
    formData.append("file", form.file.file);
    formData.append("amount", form.amount);
    formData.append("name", form.documentName);
    formData.append("recordId", form.recordId);
    formData.append("queryType", form.queryType);

    if (!form.recordId) {
      return setError("Document Id is missing");
    }
    setLoading(true);
    try {
      const token = await getToken();
      const headers = {
        authorization: `bearer ${token}`,
      };
      const url = `${constants.NEW_DOMAIN}/api/v1/channelPartnerLeads/updateRecord/${drawerData._id}`;
      const res = await axios.put(url, formData, { headers });

      // TODO: update the logic to call the API again
      //update the record in table
      setRows((prev) => {
        const updatedRows = prev.filter((data) => {
          if (data.recordId === drawerData.recordId) {
            return false;
          }
          return true;
        });
        return updatedRows;
      });
      setLoading(false);
      setDrawerData(false);
      message.success("Data updated successfully");
    } catch (error) {
      setLoading(false);
      setError(error.message || "something went wrong , try again later");
    }
  };

  const columns = [
    {
      title: (
        <Space direction="vertical" size={4}>
          <span>Name</span>
        </Space>
      ),
      dataIndex: "name",
      key: "name",
      render: (text) => <Typography.Text>{text}</Typography.Text>,
    },
    {
      title: (
        <Space direction="vertical" size={4}>
          <span>Phone</span>
        </Space>
      ),
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: <span>Issue In</span>,
      dataIndex: "queryType",
      key: "queryType",
      render: (data, record) => {
        return (
          <div>
            <Tag color="gold" style={{ marginBottom: "4px" }}>
              {data}
            </Tag>
            <br />
            {record.queryType === "payment" && <Tag color="blue">INR {record.amount}</Tag>}
            {record.queryType === "document" && <Tag color="blue">{record.documentName}</Tag>}
          </div>
        );
      },
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",

      render: (text) => (
        <div
          style={{
            maxWidth: 300, // enforce cell max width
            // whiteSpace: "nowrap",
            color: "brown",
          }}
          title={text} // hover shows full text
        >
          {text}
        </div>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <a
          onClick={() => {
            // form.setFieldsValue({ ...record, followupDate: record.followupDate ? dayjs(record.followupDate) : null, id: record._id });
            setDrawerData(record);
          }}
        >
          action <EditOutlined />
        </a>
      ),
    },
  ];

  return (
    <div style={{ padding: "12px" }}>
      <Typography.Title level={4} style={{ margin: "8px 0 16px" }}>
        Corrections / Descripencies
      </Typography.Title>

      {error ? <Alert style={{ margin: "7px 0" }} message="Error" description={error} type="error" showIcon closable /> : null}

      <Drawer
        title="Student Details"
        closable={{ "aria-label": "Close Button" }}
        size="large"
        onClose={() => {
          setDrawerData(false);
          form.resetFields();
        }}
        destroyOnClose
        afterOpenChange={(visible) => {
          if (visible) {
            form.setFieldsValue({ ...drawerData, followupDate: drawerData.followupDate ? dayjs(drawerData.followupDate) : null, id: drawerData._id });
          } else {
            form.resetFields();
          }
        }}
        open={drawerData}
      >
        <Divider orientation="middle">
          <h2 style={{ color: "gray" }}>Old Document</h2>
        </Divider>
        <Card
          hoverable
          style={{ maxWidth: 400 }}
          cover={<Image height={200} style={{ objectFit: "cover" }} draggable={false} alt="example" src={drawerData.url} />}
        >
          <Meta title={drawerData.queryType === "payment" ? `₹ ${drawerData.amount}` : drawerData.name} description={"Comments : " + drawerData.comments} />
        </Card>

        {drawerData.queryType === "payment" ? (
          <div>
            <Divider orientation="middle">
              <h2 style={{ color: "#971eff" }}>Update Payment Details</h2>
            </Divider>
            <Form style={{ maxWidth: 400 }} form={form} layout="vertical" size="small" onFinish={updateDetails}>
              <Form.Item name="recordId" hidden rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="queryType" hidden rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="amount" label="Amount" rules={[{ required: true }]}>
                <Input prefix="INR" type="number" />
              </Form.Item>
              <Form.Item name="file" label="Payment Screenshot" rules={[{ required: true }]}>
                <Upload
                  listType="picture"
                  beforeUpload={() => {
                    return false;
                  }}
                >
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
              </Form.Item>
              {error && <Alert style={{ margin: "7px 0" }} message="Error" description={error} type="error" showIcon closable />}

              <Form.Item>
                <Space>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Update
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
        ) : (
          <div>
            <Divider orientation="middle">
              <h2 style={{ color: "#971eff" }}>Update {drawerData.documentName}</h2>
            </Divider>
            <Form form={form} layout="vertical" size="small" style={{ maxWidth: 400 }} onFinish={updateDetails}>
              <Form.Item name="recordId" hidden rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="queryType" hidden rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="documentName" label="Document Title" rules={[{ required: true }]}>
                <Select placeholder="Select which doc you're uploading">
                  <Option value="passport-student">Student's Passport</Option>
                  <Option value="passport-parent">Parent's Passport</Option>
                  <Option value="birth-certificate">Birth Certificate</Option>
                  <Option value="noc">NOC</Option>
                  <Option value="pancard-parent">Parent's PAN CARD</Option>
                  <Option value="passport-cover">Passport Cover</Option>
                </Select>
              </Form.Item>
              <Form.Item name="file" label="Document PDF" rules={[{ required: true }]}>
                <Upload
                  listType="picture"
                  accept=".pdf"
                  beforeUpload={() => {
                    return false;
                  }}
                >
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
              </Form.Item>
              {error && <Alert style={{ margin: "7px 0" }} message="Error" description={error} type="error" showIcon closable />}

              <Form.Item>
                <Space>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    Update Document
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
        )}
      </Drawer>
      <Table tableLayout="fixed" rowKey="recordId" size="small" loading={loading} dataSource={rows} columns={columns} scroll={{ x: true }} />
    </div>
  );
};

export default Discrepencies;
